import { GipReportForm } from '@app/modules/audit/modules/global-audit/screens/gip/gip-report/config/form/GipReportForm';
import { useGipReportDefaultValues } from '@app/modules/audit/modules/global-audit/screens/gip/gip-report/config/form/hooks/useGipReportDefaultValues';
import { toDateTimeStr } from '@mi-front/core';
import { Form } from '@mi-front/ui';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { useWizardWithData } from '../../../../../../../../../core/hooks/WizardWithData';
import { WizardActionsFormik } from '../../../wizard/actions/WizardActions';
import { GipAodRuleWizardValues } from '../types';

export const AodGipReportConfigForm: React.FC = () => {
  const { $t } = useIntl();
  const wizard = useWizardWithData<GipAodRuleWizardValues>();
  const values = {
    ...useGipReportDefaultValues(wizard.data.reportConfig ?? {}),
    from: toDateTimeStr(moment().startOf('day').subtract(3, 'months')),
    to: toDateTimeStr(moment().endOf('day')),
    _fixedDateRange: true,
  };

  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        advertisers: yup
          .array(
            yup.object().shape({
              name: yup.string().required(),
            }),
          )
          .min(
            1,
            $t({
              id: 'audit.aod.gip.atLeastOneAdvertiser',
              defaultMessage: 'At least one advertiser must be selected',
            }),
          ),
      }),
    [$t],
  );

  return (
    <Form
      initialValues={values}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        wizard.setData({
          reportConfig: values,
        });
      }}
      actions={() => <WizardActionsFormik />}
    >
      <GipReportForm />
    </Form>
  );
};
